module.exports = __webpack_public_path__ + "img/1475430651.0c0b1de7.jpg";